<template>
  <div>
    <!-- 标题（左对齐） -->
    <h3
      class="font-medium text-[#1A1A1A]"
      :class="isPC ? 'mb-[40px] text-[28px]' : 'mb-[32px] text-[32px]'"
    >
      {{ title }}
    </h3>

    <!-- 选项网格：H5 每行 2 个；PC 每行 3 个 -->
    <div
      :class="isPC
        ? 'grid grid-cols-3 gap-x-[12px] gap-y-[12px]'
        : 'grid grid-cols-2 gap-x-[16px] gap-y-[28px]'"
    >
      <button
        v-for="reason in reasons"
        :key="reason.code"
        type="button"
        :class="[
          isPC
            ? 'rounded-[8px] px-[16px] h-[50px] text-[18px] leading-tight'
            : 'rounded-[16px] px-[24px] py-[12px] text-[32px] leading-tight',
          'border border-solid',
          selectedCode === reason.code
            ? 'border-[#0F1112] bg-white text-[#0F1112] font-medium'
            : 'border-[#939393] bg-white text-[#939393]',
        ]"
        @click="selectedCode = reason.code"
      >
        {{ $label(reason.label) }}
      </button>
    </div>

    <!-- 提交按钮 -->
    <button
      type="button"
      class="flex mx-auto items-center justify-center rounded-[44px] font-medium text-white outline-none border-none"
      :class="[
        isPC
          ? 'mt-[48px] w-[360px] h-[50px] text-[20px]'
          : 'mt-[70px] w-full h-[88px] text-[32px]',
        selectedCode ? 'bg-[#121212]' : 'bg-[#bfc0c2]',
      ]"
      :disabled="!selectedCode"
      @click="handleSubmit"
    >
      {{ submitText }}
    </button>
  </div>
</template>

<script lang="ts">
import { ref, watch } from 'vue-demi';
import { useLocaleString } from '@ark/web-shared/use';
import type { PresetReason } from '../../shared/types';
const __sfc_main = {};
__sfc_main.props = {
  show: {
    key: "show",
    required: true,
    type: Boolean
  },
  title: {
    key: "title",
    required: true,
    type: String
  },
  submitText: {
    key: "submitText",
    required: true,
    type: String
  },
  reasons: {
    key: "reasons",
    required: true,
    type: Array
  },
  defaultCode: {
    key: "defaultCode",
    required: false,
    type: [String, null]
  },
  isPC: {
    key: "isPC",
    required: true,
    type: Boolean
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const $label = useLocaleString();
  const props = __props;
  const emit = __ctx.emit;
  const selectedCode = ref<string | null>(null);

  /** 打开弹窗时回显上次选择 */
  watch(() => props.show, val => {
    if (val) {
      selectedCode.value = props.defaultCode || null;
    }
  }, {
    immediate: true
  });
  function handleSubmit() {
    if (!selectedCode.value) return;
    const matched = props.reasons.find(r => r.code === selectedCode.value);
    emit('submit', {
      presetCode: selectedCode.value,
      label: matched ? matched.label : {}
    });
  }
  return {
    $label,
    selectedCode,
    handleSubmit
  };
};
export default __sfc_main;
</script>
